import React from 'react';

const AvailabilityFooter = () => {
  return (
      <div className="availabilityFooter">
        <p>Powered by HTI  |  <a href="http://www.htihospitality.tech" target="_blank" rel="noopener noreferrer">www.htihospitality.tech</a></p>
      </div>
  )
};

export default AvailabilityFooter;


// WEBPACK FOOTER //
// ./src/components/AvailabilityFooterComponent.js